/* ============================================================================
   MOTIONFLUID MINIMAL — movimiento e interacción (reemplaza motion-enhancements.js)
   ----------------------------------------------------------------------------
   Efectos portados a JS sin dependencias, con ideas de React Bits:
     - Aparición al hacer scroll (AnimatedContent / FadeContent)  [data-mm-reveal]
     - Título que entra palabra por palabra (BlurText)            [data-mm-words]
     - Parallax suave de imágenes                                 [data-mm-parallax="0.06"]
     - Profundidad con el cursor en el hero                       [data-mm-drift] > [data-mm-depth="10"]
     - Conteo de cifras al aparecer (CountUp)                     [data-mm-count]
     - Luz que sigue al cursor (SpotlightCard)                    [data-mm-spot]
   Más: header que se esconde al bajar y vuelve al subir, menú móvil,
   rebote del contador del carrito y acordeones del footer en teléfono.
   Solo transform/opacity. Con "reducir movimiento" no se anima nada.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__mmMotion) return;
  window.__mmMotion = true;

  var d = document, html = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var anim = html.classList.contains('mm-anim') && !reduce && 'IntersectionObserver' in window;
  if (!anim) html.classList.remove('mm-anim');

  function $$(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }

  /* ---------- 1) Título palabra por palabra ---------- */
  function splitWords(el) {
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var parts = child.textContent.split(/(\s+)/);
          var frag = d.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(d.createTextNode(p)); return; }
            var s = d.createElement('span');
            s.className = 'mm-word';
            s.style.setProperty('--mm-i', i++);
            s.textContent = p;
            frag.appendChild(s);
          });
          node.replaceChild(frag, child);
        } else if (child.nodeType === 1 && child.tagName !== 'BR') {
          walk(child);
        }
      });
    })(el);
    el.classList.add('is-split');
  }

  /* ---------- 2) Aparición al hacer scroll ---------- */
  function initReveal() {
    $$('[data-mm-stagger]').forEach(function (group) {
      $$('[data-mm-reveal]', group).forEach(function (el, idx) {
        el.style.setProperty('--mm-i', Math.min(idx, 8));
      });
    });
    $$('[data-mm-words]').forEach(function (el) {
      if (anim) splitWords(el); else el.classList.add('is-split');
      if (!el.hasAttribute('data-mm-reveal')) el.setAttribute('data-mm-reveal', '');
    });
    var els = $$('[data-mm-reveal]');
    if (!anim) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var sc = e.target.closest('.mm-xs-scroll');
        var group = (sc && window.innerWidth < 750) ? $$('[data-mm-reveal]', sc) : [e.target];
        group.forEach(function (el) { el.classList.add('is-in'); io.unobserve(el); });
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 3) Parallax ---------- */
  function initParallax() {
    var items = $$('[data-mm-parallax]').map(function (el) {
      return { el: el, ref: el.parentElement || el, speed: parseFloat(el.getAttribute('data-mm-parallax')) || 0.06 };
    });
    if (!items.length || reduce) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      var scale = window.innerWidth < 750 ? 0.5 : 1;
      items.forEach(function (it) {
        var r = it.ref.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var off = (r.top + r.height / 2) - vh / 2;
        var y = -off * it.speed * scale;
        it.el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ---------- 4) Profundidad con el cursor (hero) ---------- */
  function initDrift() {
    if (reduce || !fine) return;
    $$('[data-mm-drift]').forEach(function (box) {
      var layers = $$('[data-mm-depth]', box).map(function (el) {
        return { el: el, depth: parseFloat(el.getAttribute('data-mm-depth')) || 8, x: 0, y: 0 };
      });
      var tx = 0, ty = 0, raf = null;
      function step() {
        var moving = false;
        layers.forEach(function (l) {
          var gx = tx * l.depth, gy = ty * l.depth;
          l.x += (gx - l.x) * 0.08; l.y += (gy - l.y) * 0.08;
          if (Math.abs(gx - l.x) > 0.05 || Math.abs(gy - l.y) > 0.05) moving = true;
          l.el.style.transform = 'translate3d(' + l.x.toFixed(2) + 'px,' + l.y.toFixed(2) + 'px,0)';
        });
        raf = moving ? requestAnimationFrame(step) : null;
      }
      function kick() { if (!raf) raf = requestAnimationFrame(step); }
      box.addEventListener('pointermove', function (e) {
        var r = box.getBoundingClientRect();
        tx = -((e.clientX - r.left) / r.width - 0.5) * 2;
        ty = -((e.clientY - r.top) / r.height - 0.5) * 2;
        kick();
      });
      box.addEventListener('pointerleave', function () { tx = 0; ty = 0; kick(); });
    });
  }

  /* ---------- 5) Conteo de cifras ---------- */
  function initCount() {
    var els = $$('[data-mm-count]');
    if (!els.length) return;
    function run(el) {
      var final = el.textContent.trim();
      var m = final.match(/^(\D*)([\d,]+)(\D*)$/);
      if (!m || reduce) return;
      var to = parseInt(m[2].replace(/,/g, ''), 10);
      if (!to) return;
      var t0 = null, dur = 1300;
      function fmt(n) { return m[1] + n.toLocaleString('en-US') + m[3]; }
      function step(t) {
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = p < 1 ? fmt(Math.round(to * eased)) : final;
        if (p < 1) requestAnimationFrame(step);
      }
      el.textContent = fmt(0);
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        run(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 6) Luz que sigue al cursor ---------- */
  function initSpot() {
    if (!fine) return;
    d.addEventListener('pointermove', function (e) {
      var el = e.target.closest && e.target.closest('[data-mm-spot]');
      if (!el) return;
      var r = el.getBoundingClientRect();
      el.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      el.style.setProperty('--my', (e.clientY - r.top) + 'px');
    }, { passive: true });
  }

  /* ---------- 7) Header: se esconde al bajar, vuelve al subir ---------- */
  function initHeader() {
    var hdr = d.querySelector('[data-mm-header]');
    if (!hdr) return;
    var sec = hdr.closest('.shopify-section') || hdr;
    var lastY = window.scrollY, ticking = false, stickyTop = -1;
    function setHeight() {
      html.style.setProperty('--header-height', sec.offsetHeight + 'px');
      html.style.setProperty('--header-height-live', sec.offsetHeight + 'px');
    }
    function searchOpen() {
      var p = d.querySelector('.ss-panel');
      return p && p.style.display === 'block';
    }
    function update() {
      var y = window.scrollY;
      sec.classList.toggle('mm-scrolled', y > 4);
      var busy = html.classList.contains('mm-lock') || hdr.contains(d.activeElement) || searchOpen() ||
        hdr.matches(':hover');
      if (y > lastY + 6 && y > 160 && !busy) sec.classList.add('mm-hdr-hidden');
      else if (y < lastY - 6 || y <= 160) sec.classList.remove('mm-hdr-hidden');
      /* barras fijas de la página (filtros) se acomodan bajo el header cuando se ve */
      var top = sec.classList.contains('mm-hdr-hidden') ? 0 : sec.offsetHeight;
      if (top !== stickyTop) { stickyTop = top; html.style.setProperty('--mm-sticky-top', top + 'px'); }
      if (Math.abs(y - lastY) > 6) lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', setHeight, { passive: true });
    hdr.addEventListener('focusin', function () { sec.classList.remove('mm-hdr-hidden'); });
    setHeight(); update();
  }

  /* ---------- 8) Menú móvil ---------- */
  function initDrawer() {
    var panel = d.querySelector('[data-mm-drawer]');
    if (!panel) return;
    /* fuera del header fijo: así ningún transform del header lo desplaza */
    if (panel.parentElement !== d.body) d.body.appendChild(panel);
    var openers = $$('[data-mm-drawer-open]');
    var lastFocus = null;
    $$('[data-mm-stag]', panel).forEach(function (el, i) { el.style.setProperty('--mm-i', Math.min(i, 12)); });
    function set(open) {
      panel.classList.toggle('is-open', open);
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      html.classList.toggle('mm-lock', open);
      openers.forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      if (open) {
        lastFocus = d.activeElement;
        var first = panel.querySelector('[data-mm-drawer-close]');
        if (first) setTimeout(function () { first.focus(); }, 60);
      } else if (lastFocus && lastFocus.focus) {
        lastFocus.focus();
      }
    }
    openers.forEach(function (b) { b.addEventListener('click', function () { set(true); }); });
    $$('[data-mm-drawer-close]', panel).forEach(function (b) { b.addEventListener('click', function () { set(false); }); });
    $$('a', panel).forEach(function (a) { a.addEventListener('click', function () { set(false); }); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('is-open')) set(false); });
  }

  /* ---------- 9) Rebote del contador del carrito ---------- */
  function initCartBump() {
    var icon = d.getElementById('cart-icon-bubble');
    if (!icon || !('MutationObserver' in window)) return;
    new MutationObserver(function () {
      var b = icon.querySelector('.cart-count-bubble');
      if (!b) return;
      b.classList.remove('mm-bump'); void b.offsetWidth; b.classList.add('mm-bump');
    }).observe(icon, { childList: true, subtree: true, characterData: true });
  }

  /* ---------- 10) Conversación de contacto: se reproduce una vez al aparecer ---------- */
  function initChat() {
    $$('[data-mm-chat]').forEach(function (chat) {
      var steps = $$('[data-mm-step]', chat);
      if (!anim) {
        steps.forEach(function (s) { if (!s.classList.contains('mm-typing')) s.classList.add('is-on'); });
        chat.classList.add('is-done');
        return;
      }
      var played = false;
      function play() {
        if (played) return; played = true;
        var t = 250;
        steps.forEach(function (s) {
          var kind = s.getAttribute('data-mm-step');
          if (kind === 'typing') {
            (function (el, at) {
              setTimeout(function () { el.classList.add('is-on'); }, at);
              setTimeout(function () { el.classList.remove('is-on'); }, at + 1100);
            })(s, t);
            t += 1100;
          } else {
            (function (el, at) { setTimeout(function () { el.classList.add('is-on'); }, at); })(s, t);
            t += kind === 'card' ? 900 : (kind === 'out' ? 800 : 450);
          }
        });
        setTimeout(function () { chat.classList.add('is-done'); }, t + 500);
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { play(); io.disconnect(); } });
      }, { threshold: 0.4 });
      io.observe(chat);
    });
  }

  /* ---------- 11) Hero "circuito vivo": se dibuja, acciona la válvula, corre el fluido ---------- */
  function initCircuit() {
    $$('[data-mmc]').forEach(function (panel) {
      var parts = $$('[data-mmc-part]', panel);
      function hot(name) {
        parts.forEach(function (el) { el.classList.toggle('is-hot', !!name && el.getAttribute('data-mmc-part') === name); });
        panel.classList.toggle('is-hot', !!name);
      }
      parts.forEach(function (el) {
        var name = el.getAttribute('data-mmc-part');
        el.addEventListener('pointerenter', function () { hot(name); });
        el.addEventListener('pointerleave', function () { hot(null); });
        el.addEventListener('focus', function () { hot(name); });
        el.addEventListener('blur', function () { hot(null); });
      });
      /* clic en una pieza del dibujo → su categoría (el enlace del renglón) */
      $$('.mmc-svg [data-mmc-part]', panel).forEach(function (el) {
        el.addEventListener('click', function () {
          var a = panel.querySelector('.mm-hc__row[data-mmc-part="' + el.getAttribute('data-mmc-part') + '"]');
          var href = a && a.getAttribute('href');
          if (href && href !== '#') window.location.href = href;
        });
      });
      $$('path.mmc-l:not(.mmc-pilot)', panel).forEach(function (l, i) { l.style.transitionDelay = Math.min(i * 24, 820) + 'ms'; });
      if (!anim) { panel.classList.add('is-drawn', 'is-ext', 'is-done'); return; }
      var started = false;
      function run() {
        if (started) return; started = true;
        requestAnimationFrame(function () { panel.classList.add('is-drawn'); });
        setTimeout(function () { panel.classList.add('is-shift'); }, 1750);
        setTimeout(function () { panel.classList.add('is-flow', 'is-ext'); }, 2050);
        setTimeout(function () { panel.classList.remove('is-shift', 'is-flow'); panel.classList.add('is-done'); }, 4400);
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { run(); io.disconnect(); } });
      }, { threshold: 0.25 });
      io.observe(panel);
    });
  }

  /* ---------- 12) Hero video: una división por diapositiva; el progreso es la duración real del video ---------- */
  function initHeroVideo() {
    $$('[data-mm-hv]').forEach(function (root) {
      if (root.__mmHv) return;
      root.__mmHv = true;
      var slides = $$('[data-mm-hv-slide]', root);
      var tabs = $$('[data-mm-hv-tab]', root);
      var btn = root.querySelector('[data-mm-hv-pause]');
      var n = slides.length;
      if (!n) return;
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      var saveData = !!(navigator.connection && navigator.connection.saveData);
      /* con "reducir movimiento" o ahorro de datos: pósters fijos hasta que la persona dé play */
      var useVideo = !reduce && !saveData;
      var holdMs = (parseFloat(root.getAttribute('data-mm-hv-fallback')) || 6) * 1000;
      var cur = 0, userPaused = reduce, inView = true, raf = 0, last = 0, elapsed = 0, mode = 'timer';

      function vid(i) { return slides[i] ? slides[i].querySelector('video') : null; }
      function prep(i) {
        var v = vid(i);
        if (!v || !useVideo || v.getAttribute('src')) return v;
        v.src = v.getAttribute(mobile ? 'data-src-m' : 'data-src');
        v.preload = 'auto';
        return v;
      }
      function running() { return !userPaused && inView && !d.hidden; }
      function setFill(p) {
        var f = tabs[cur] && tabs[cur].querySelector('.mm-hv__fill');
        if (f) f.style.transform = 'scaleX(' + Math.max(0, Math.min(1, p)) + ')';
      }
      function tick(t) {
        raf = 0;
        if (!running()) return;
        var p;
        if (mode === 'video') {
          var v = vid(cur);
          p = v && v.duration ? v.currentTime / v.duration : 0;
          if (p > 0.4 && n > 1) prep((cur + 1) % n);
        } else {
          elapsed += last ? t - last : 0;
          p = elapsed / holdMs;
          if (p >= 1 && n > 1) { go((cur + 1) % n); return; }
        }
        last = t;
        setFill(p);
        raf = requestAnimationFrame(tick);
      }
      function loop() { if (!raf) { last = 0; raf = requestAnimationFrame(tick); } }
      function toTimer() { mode = 'timer'; elapsed = 0; loop(); }
      function play() {
        var v = useVideo ? prep(cur) : null;
        if (!v) { mode = 'timer'; loop(); return; }
        mode = 'video';
        if (n === 1) v.loop = true;
        var pr = v.play();
        /* autoplay bloqueado (p. ej. modo de bajo consumo): seguir con pósters */
        if (pr && pr.catch) pr.catch(function () { if (!userPaused) { useVideo = false; toTimer(); } });
        loop();
      }
      function hold() {
        var v = vid(cur);
        if (v) v.pause();
        if (raf) { cancelAnimationFrame(raf); raf = 0; }
      }
      function sync() { if (running()) play(); else hold(); }

      function go(i) {
        if (i === cur) return;
        var prev = cur, pv = vid(prev);
        if (raf) { cancelAnimationFrame(raf); raf = 0; }
        setFill(0);
        cur = i; elapsed = 0; last = 0;
        slides.forEach(function (s, k) {
          var on = k === i;
          s.classList.toggle('is-active', on);
          s.classList.toggle('is-shown', on);
          if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
          $$('a', s).forEach(function (a) { if (on) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); });
        });
        tabs.forEach(function (b, k) {
          b.classList.toggle('is-active', k === i);
          b.setAttribute('aria-selected', k === i ? 'true' : 'false');
        });
        var v = vid(i);
        if (v && v.getAttribute('src')) { try { v.currentTime = 0; } catch (e) {} }
        /* el video saliente sigue corriendo durante el fundido y luego se rebobina */
        if (pv) setTimeout(function () { if (cur !== prev) { pv.pause(); try { pv.currentTime = 0; } catch (e) {} } }, 1100);
        sync();
      }

      slides.forEach(function (s, k) {
        var v = vid(k);
        if (!v) return;
        v.addEventListener('playing', function () { v.classList.add('is-on'); });
        v.addEventListener('ended', function () { if (k === cur && n > 1) go((cur + 1) % n); });
        v.addEventListener('error', function () { if (k === cur) toTimer(); });
      });
      tabs.forEach(function (b) {
        b.addEventListener('click', function () { go(parseInt(b.getAttribute('data-mm-hv-tab'), 10) || 0); });
      });
      function setBtn() {
        root.classList.toggle('is-paused', userPaused);
        if (!btn) return;
        btn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        btn.setAttribute('aria-label', btn.getAttribute(userPaused ? 'data-label-play' : 'data-label-pause'));
      }
      if (btn) btn.addEventListener('click', function () {
        userPaused = !userPaused;
        if (!userPaused && !saveData) useVideo = true; /* dar play es permiso explícito */
        setBtn(); sync();
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { inView = es[0].isIntersecting; sync(); }, { threshold: 0.15 }).observe(root);
      }
      d.addEventListener('visibilitychange', sync);
      /* alto = pantalla menos lo que hay arriba (aviso + header), para que las pestañas queden a la vista */
      function fit() { root.style.setProperty('--mm-hv-top', Math.max(0, Math.round(root.getBoundingClientRect().top + window.scrollY)) + 'px'); }
      fit();
      window.addEventListener('resize', fit, { passive: true });
      setBtn();
      requestAnimationFrame(function () { slides[0].classList.add('is-shown'); });
      sync();
    });
  }

  /* ---------- 14) Lámina técnica (mm-plano): resaltado por pieza + dibujo único al aparecer ---------- */
  function initPlano() {
    $$('[data-mmp]').forEach(function (root) {
      if (root.__mmp) return;
      root.__mmp = true;
      var parts = $$('[data-mmp-part]', root);
      var cur = null;
      function hot(name) {
        if (name === cur) return;
        cur = name;
        root.classList.toggle('is-hot', !!name);
        parts.forEach(function (el) { el.classList.toggle('is-hot', !!name && el.getAttribute('data-mmp-part') === name); });
      }
      root.__mmpHot = hot;
      parts.forEach(function (el) {
        var name = el.getAttribute('data-mmp-part');
        el.addEventListener('pointerenter', function () { hot(name); });
        el.addEventListener('pointerleave', function () { hot(null); });
        el.addEventListener('focus', function () { hot(name); });
        el.addEventListener('blur', function () { hot(null); });
      });
      /* clic sobre una pieza del dibujo (no en un globo, que ya es enlace) → su categoría */
      $$('.mmp-svg .mmp-g[data-mmp-part]', root).forEach(function (el) {
        el.addEventListener('click', function () {
          var a = root.querySelector('.mm-p__row[data-mmp-part="' + el.getAttribute('data-mmp-part') + '"]');
          var href = a && a.getAttribute('href');
          if (href && href !== '#') window.location.href = href;
        });
      });
      $$('.mm-p__bom li', root).forEach(function (li, i) { li.style.setProperty('--i', i + 1); });

      if (!anim) { root.classList.add('is-drawn', 'is-done'); return; }
      var started = false;
      function run() {
        if (started) return;
        started = true;
        requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-drawn'); }); });
        /* al terminar se quitan los trazos discontinuos del dibujo (queda el estado final, sin bucles) */
        setTimeout(function () { root.classList.add('is-done'); }, 3600);
      }
      var sheet = root.querySelector('.mm-p__sheet') || root;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { run(); io.disconnect(); } });
      }, { threshold: 0.2 });
      io.observe(sheet);
    });
    /* editor de temas: al elegir un bloque "pieza", se enciende esa pieza */
    if (!initPlano.__ev) {
      initPlano.__ev = true;
      d.addEventListener('shopify:block:select', function (e) {
        var sec = e.target && e.target.closest && e.target.closest('[data-mmp]');
        var row = e.target && e.target.querySelector && e.target.querySelector('[data-mmp-part]');
        if (sec && sec.__mmpHot && row) sec.__mmpHot(row.getAttribute('data-mmp-part'));
      });
      d.addEventListener('shopify:block:deselect', function (e) {
        var sec = e.target && e.target.closest && e.target.closest('[data-mmp]');
        if (sec && sec.__mmpHot) sec.__mmpHot(null);
      });
    }
  }

  /* ---------- 15) Hub de marca: control segmentado con indicador deslizante (Pill Nav)
     y portadas de catálogo que se inclinan hacia el cursor (Tilted Card) ---------- */
  function initBrandHub() {
    $$('[data-mm-bh]').forEach(function (root) {
      if (root.__mmBh) return;
      root.__mmBh = true;
      var seg = root.querySelector('[data-mm-bh-tabs]');
      var tabs = seg ? $$('[role="tab"]', seg) : [];
      var ind = seg && seg.querySelector('.mm-bh__ind');
      var panes = $$('[data-pane-body]', root);
      function place(btn, instant) {
        if (!ind || !btn) return;
        if (instant) ind.style.transition = 'none';
        ind.style.setProperty('--bh-x', btn.offsetLeft + 'px');
        ind.style.setProperty('--bh-w', btn.offsetWidth + 'px');
        if (instant) { void ind.offsetWidth; ind.style.transition = ''; }
      }
      function current() { return seg && seg.querySelector('[aria-selected="true"]'); }
      function show(name, focus) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-pane') === name;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
          if (on) { place(t); if (focus) t.focus(); }
        });
        panes.forEach(function (p) {
          var on = p.getAttribute('data-pane-body') === name;
          p.classList.toggle('is-active', on);
          if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
        });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(t.getAttribute('data-pane')); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          show(next.getAttribute('data-pane'), true);
        });
      });
      if (seg) {
        place(current(), true);
        seg.classList.add('is-ready');
        window.addEventListener('resize', function () { place(current(), true); }, { passive: true });
        if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { place(current(), true); });
      }

      /* selector ES/EN del PDF: cambia enlace y portada de cada catálogo */
      var langSwitch = root.querySelector('[data-lang-switch]');
      if (langSwitch) {
        var langBtns = $$('[data-lang]', langSwitch);
        langBtns.forEach(function (b) {
          b.addEventListener('click', function () {
            var lang = b.getAttribute('data-lang');
            langBtns.forEach(function (x) {
              var on = x === b;
              x.classList.toggle('is-on', on);
              x.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
            $$('[data-cat-card]', root).forEach(function (card) {
              var url = card.getAttribute('data-pdf-' + lang) || card.getAttribute('data-pdf-en');
              if (url) card.setAttribute('href', url);
              var cover = card.getAttribute('data-cover-' + lang) || card.getAttribute('data-cover-en');
              var img = card.querySelector('.ahub__cover');
              if (img && cover) img.setAttribute('src', cover);
              var t = card.querySelector('[data-dl-text]');
              if (t) t.textContent = lang === 'en' ? 'Download PDF' : 'Descargar PDF';
            });
          });
        });
      }

      /* portada que se inclina hacia el cursor: solo con mouse y sin "reducir movimiento" */
      if (!fine || reduce) return;
      $$('[data-mm-tilt]', root).forEach(function (el) {
        var raf = 0, ev = null;
        function apply() {
          raf = 0;
          if (!ev) return;
          var r = el.getBoundingClientRect();
          var px = (ev.clientX - r.left) / r.width, py = (ev.clientY - r.top) / r.height;
          el.style.setProperty('--ry', ((px - 0.5) * 8).toFixed(2) + 'deg');
          el.style.setProperty('--rx', ((0.5 - py) * 8).toFixed(2) + 'deg');
          el.style.setProperty('--sx', (px * 100).toFixed(1) + '%');
          el.style.setProperty('--sy', (py * 100).toFixed(1) + '%');
        }
        el.addEventListener('pointerenter', function () { el.classList.add('is-tilt'); });
        el.addEventListener('pointermove', function (e) { ev = e; if (!raf) raf = requestAnimationFrame(apply); }, { passive: true });
        el.addEventListener('pointerleave', function () {
          ev = null;
          el.classList.remove('is-tilt');
          el.style.setProperty('--rx', '0deg');
          el.style.setProperty('--ry', '0deg');
        });
      });
    });
  }

  /* ---------- 13) Footer: acordeones cerrados en teléfono ---------- */
  function initFooter() {
    if (window.innerWidth > 749) return;
    $$('[data-mm-ftr-col]').forEach(function (det) { det.removeAttribute('open'); });
  }

  function init() {
    initReveal(); initParallax(); initDrift(); initCount(); initSpot();
    initHeader(); initDrawer(); initCartBump(); initChat(); initCircuit(); initHeroVideo(); initPlano(); initBrandHub(); initFooter();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();

  /* Editor de temas: al recargar una sección, re-inicializar sin animar */
  d.addEventListener('shopify:section:load', function () {
    $$('[data-mm-reveal]').forEach(function (el) { el.classList.add('is-in'); });
    $$('[data-mm-words]').forEach(function (el) { el.classList.add('is-split'); });
    initHeroVideo();
    initPlano();
    initBrandHub();
  });
})();
